import { RouteRecordRaw } from "vue-router";
import CompanyComponent from "@/components/netvisor/features/Company/CompanyComponent.vue";
const routePrefix = "/nv/";

const netVisorPageRoutes: RouteRecordRaw[] = [
    {
        path: `${routePrefix}company`,
        name: "Company",
        component: () => import("@/components/netvisor/features/Company/CompanyComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['netvisor', 'company'],
         },
    },
     {
        path: `${routePrefix}account`,
        name: "Account",
        component: () => import("@/components/netvisor/features/Account/AccountComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['netvisor', 'account'],
         },
    },
        {
        path: `${routePrefix}customer`,
        name: "Customer",
        component: () => import("@/components/netvisor/features/Customer/CustomerComponent.vue"),
        meta: { requiresAuth: true,
            titleTrail: ['netvisor', 'customer'],
         },
    },
];

export default netVisorPageRoutes;